import { get, post, put, del, uploadFile } from './client.js';
import type { News } from '../types/index.js';

export const newsApi = {
  list: (params?: { page?: number; per_page?: number; search?: string }) => {
    const q = new URLSearchParams();
    if (params?.page) q.append('page', params.page.toString());
    if (params?.per_page) q.append('per_page', params.per_page.toString());
    if (params?.search) q.append('search', params.search);
    const qs = q.toString();
    return get<{ data: News[]; pagination: { page: number; per_page: number; total: number } }>(
      `/news${qs ? '?' + qs : ''}`
    );
  },

  getDetail: (id: number) => get<News>(`/news/${id}`),

  create: (data: { title: string; content: string; json_ld?: Record<string, unknown> | null }) => post<News>('/news', data),

  update: (id: number, data: { title?: string; content?: string; json_ld?: Record<string, unknown> | null }) => put<News>(`/news/${id}`, data),

  delete: (id: number) => del(`/news/${id}`),
};

export function uploadNewsImage(
  file: File,
  onProgress?: (percent: number) => void,
): Promise<{ url: string }> {
  const fd = new FormData();
  fd.append('file', file);
  return uploadFile('/news/upload-image', fd, onProgress);
}
